import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { TimeSchedule } from '../models/TimeSchedule/TimeSchedule';
import { NotificationService } from '../../core/services/notification.service';

@Injectable()
export class TimeScheduleService extends DataService<TimeSchedule> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = "timeSchedule";
	}

}